import {h} from "preact";

import "./Tabs.scss";

const tabs = ["On Air", "Schedule", "Message", "Webcam", "Catchup"];

export default function Tabs(props: { activeTabIndex: number, doScroll: (to: "onair" | "schedule" | "message" | "webcam" | "catchup") => any }) {
    return (
        <div class="tabs">
            {tabs.map(
                (tab, idx) =>
                    <div
                        className={`tab ${props.activeTabIndex === idx && "active"}`}
                        onClick={
                            () => props.doScroll(tab.replace(" ", "").toLowerCase() as any /* TODO not nice */)
                        }>{tab}</div>
            )}
        </div>
    )
}
